import { Flex } from "@chakra-ui/react";
import { AnimatePresence } from "framer-motion";
import React, { useState } from "react";
import { ChakraBox } from "ui/chakra-framer";
import { Copilot } from "./copilot";
import { Prompt } from "./prompt";

const promptVariants = {
  hidden: { opacity: 0, y: -100, transition: { duration: 0.6 } },
  visible: { opacity: 1, y: 0 },
};

const copilotVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export function HeroAnimation() {
  const [promptAnimationActive, setPromptAnimationActive] = useState(true);
  const [copilotGraphActive, setCopilotGraphActive] = useState(false);

  const transitionAnimation = () => {
    let secondTimeout: NodeJS.Timeout | undefined;

    const deactivatePromptAnimation = () => {
      setPromptAnimationActive(false);

      secondTimeout = setTimeout(activateCopilotGraph, 500);
    };

    const activateCopilotGraph = () => {
      setCopilotGraphActive(true);
    };

    const firstTimeout = setTimeout(deactivatePromptAnimation, 500);

    return () => {
      clearTimeout(firstTimeout);
      clearTimeout(secondTimeout);
    };
  };

  return (
    <Flex
      justify={{ base: "center", lg: "unset" }}
      fontFamily="inter"
      w="100%"
      minH={{ base: "280px", sm: "300px", md: "500px" }}
      maxH={{ base: "280px", sm: "400px", md: "600px" }}
      pos={{ base: "relative", lg: "unset" }}
    >
      <Flex
        align={{ base: "start", lg: "center" }}
        pos={{ base: "relative", lg: "absolute" }}
        top={{ base: "unset", lg: 0 }}
        left={{ base: "unset", lg: "calc(50%)", xl: "calc(50% + 40px)" }}
        w={{ base: "100%", lg: "54%", xl: "50%" }}
        maxW={{ base: "100%", sm: "500px", md: "680px", lg: "780px" }}
        mx={{ base: "auto", lg: "unset" }}
        height="100%"
      >
        <AnimatePresence initial={false} mode="sync">
          {promptAnimationActive && (
            <ChakraBox
              key="prompt"
              id="prompt-container"
              alignItems="start"
              pos="absolute"
              mt={{ base: 12, lg: -24 }}
              minW="100%"
              w={{ base: "auto", lg: "100%" }}
              ml={{ base: "auto", lg: "unset" }}
              left={{ base: 0, lg: "unset" }}
              right={{ base: -16, sm: 0, lg: "unset" }}
              variants={promptVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <Prompt
                isAnimationPlaying={promptAnimationActive}
                fontSize={{ base: "9px", sm: "xs", md: "sm", xl: "md" }}
                lineHeight={{ base: "12px", sm: "16px", md: "18px", xl: "20px" }}
                placeholder={{ text: "What do you want to see?" }}
                textSequence={[
                  {
                    text: "How much revenue have I earned from my campaigns this year?",
                    onComplete: transitionAnimation,
                  },
                ]}
              />
            </ChakraBox>
          )}

          {copilotGraphActive && (
            <ChakraBox
              key="copilot"
              id="copilot-container"
              pos="absolute"
              w={{ base: "auto", lg: "100%" }}
              ml={{ base: "auto", lg: "unset" }}
              left={{ base: 0, lg: "unset" }}
              right={{ base: -16, sm: 0, lg: "unset" }}
              variants={copilotVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <Copilot
                animationActive={copilotGraphActive}
                opacity={1}
                maxW={{ base: "100%", xl: "none" }}
                maxH="100%"
              />
            </ChakraBox>
          )}
        </AnimatePresence>
      </Flex>
    </Flex>
  );
}
